import {useState} from 'react';
import {Badge, Button} from '@mantine/core';
import {FiFilter} from 'react-icons/fi';
import {FilterDrawer} from '../drawers/FilterDrawer';
import {useBillableEventsFilter} from '../hooks/useBillableEventsFilter';
import {I18n} from '@aws-amplify/core';

export const FilterRecordsButton = () => {
    const [opened, setOpened] = useState(false);
    const {filters} = useBillableEventsFilter();

    const activeCount = Object.keys(filters).length;

    return (
        <>
            <div style={{position: 'relative'}}>
                <Button
                    variant="outline"
                    leftSection={<FiFilter size={16}/>}
                    onClick={() => setOpened(true)}
                >
                    {I18n.get('Filter')}
                </Button>
                {activeCount > 0 && (
                    <Badge
                        size="xs"
                        variant="filled"
                        color="blue"
                        style={{
                            position: 'absolute',
                            top: -8,
                            right: -8,
                            minWidth: 16,
                            height: 16,
                            padding: 0,
                        }}
                    >
                        {activeCount}
                    </Badge>
                )}
            </div>
            <FilterDrawer
                opened={opened}
                onClose={() => setOpened(false)}
            />
        </>
    );
};
